import { select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { PaymentHeader } from '@cemex-core/types-v1';
import { TranslationService } from '@cemex-core/angular-localization-v7';

import { AbstractPaymentEngine } from './abstract-payment-engine';
import { PaymentEngineConfiguration } from './payment-engine-configuration';
import { Observable, zip } from 'rxjs';
import { PaymentConfiguration } from './../models/payment-configuration';
import { PaymentRequest } from './../models/payment-request';
import { PayerBrokerRequest, PayerBrokerRequestV1 } from './../models/payer-broker-request';
import * as fromPayments from './../store/reducers/index';
import { RequestHeaders } from '@microsoft/applicationinsights-common';
import { StorageManagerService } from '@app/core/services/storage-manager.service';

export class PaymentEngineDO extends AbstractPaymentEngine {

    constructor(configuration: PaymentEngineConfiguration, t: TranslationService, private storageManagerService: StorageManagerService,) {
        super(configuration, t);
    }

    getBanks(): any {
        throw new Error('Method not implemented.');
    }

    getPaymentConfiguration(): Observable<PaymentConfiguration> {
        return zip(
            super.initPaymentConfiguration(),
            this.bankService.getBankListV2({
                companyCode: this.company.companyCode,
                countryCode: this.customer.countryCode,
                customerCode: this.customer.customerCode
            })
        ).pipe(
            map(([paymentConfiguration, banks]) => {
                paymentConfiguration.paymentMethods.forEach(pm => pm.paymentNetworks = banks);

                paymentConfiguration.paymentMethods.forEach(pm => {
                    pm.paymentNetworks = banks;
                    pm.displayName = pm.description;
                    pm.displayDescription =  this.t.pt('views.regular_payments.transfer_method_description')
                    pm.displayIcon = 'selection-container__icon cmx-icon-module-invoices-payments';
                    pm.checked = pm.code.toLowerCase() === 'transfer' ? true : false;
                });

                return paymentConfiguration;
            })
        );
    }

    createReference(request: PaymentRequest): Observable<any> {
        return this.paymentService.createReferenceV3(request);
    }

    getPayerBroker(request: PayerBrokerRequest, brokerCode: string): Observable<any> {
          let paymentType = '';
          let transactionType = '';
          let transactionDescType = '';
            ///TODO: Obtener de countryParamters
          request.paymentHeader.currencyKey = 'RD';
          this.store.pipe(
              select(fromPayments.isAdvancePayment),
              map(isAdvancePayment => {
                transactionType = isAdvancePayment ? 'AVP' : 'RGP';
                transactionDescType = isAdvancePayment ? 'Advance Payment' : 'Regular Payment';
                  if (isAdvancePayment && request.paymentType.paymentTypeCode === 'TR') {
                      paymentType = '113';
                  } else if (!isAdvancePayment && request.paymentType.paymentTypeCode === 'TR') {
                      paymentType = '1';
                  }

                  request.paymentType.paymentTypeCode = paymentType;
              })
          ).subscribe();

          const userProfile = this.storageManagerService.user_profile;
          const refreshToken = this.storageManagerService.refresh_token;
          const request2: PayerBrokerRequestV1 = {
            country: {
                countryCode: request.country.countryCode
            },
            company: {
                companyCode: request.company.companyCode,
                companyDesc: ''
            },
            payment: {
                paymentAmount: request.amount,
                fee: request.paymentHeader.fee,
                subTotal: request.paymentHeader.subTotal,
                reference: {
                    referenceNumber: request.referenceCode
                },
                transaction: {
                    transactionType: transactionType,
                    transactionDesc: transactionDescType
                },
                status: {
                    statusCode: request.paymentHeader.statusTransaction,
                    statusDesc: ''
                },
                method: {
                    methodCode: request.paymentHeader.paymentMethod,
                    methodDesc: ''
                },
                currency: {
                    currencyCode: request.paymentHeader.currencyKey,
                    currencyDesc: ''
                },
                datePayment: request.paymentHeader.datePay,
                timePayment: request.paymentHeader.timePay,
                partialPayment: '',
            },
            customer: {
                customerCode: request.customer.customerCode,
                customerDesc: request.customer.customerDesc
            },
            user: {
                userAccount: userProfile.userAccount,
                userName: userProfile.fullName
            }
            //   urlRedirect: window.location.href.substring( 0, document.location.href.lastIndexOf( '/' ))
            //       + '/return?token=' + refreshToken + '&amp;c=' + request.country.countryCode
            //       + '&amp;b=BHD01' + '&amp;r=' + request.referenceCode
          };
          return this.paymentService.getPayerBrokerV1( request2, 'BhdLeon');
    }

    callToNetworking(totalToPay: string, referenceCode: string, payerInformation: any): void {
        const action = payerInformation.urlRedirect;
        const parameters = {
            returnCode: payerInformation.returnCode
        };
        this.createFormRequestNetwork(action, 'POST', '_self', parameters);
    }

    isExternalCompany(companyCode: string): boolean {
        return false;
    }

    saveExternalOrderRelation(): any {
        throw new Error('Method not implemented.');
    }

    getHeaderPayerInformation(request: any, payerInformationResponse: any, storeDataInfo: any): any {
        const paymentHeader = request.header;
        const response = payerInformationResponse;
        let psePaymentType = paymentHeader.paymentMethod.toLowerCase() === 'TR' ? '113'
                        : paymentHeader.paymentMethod.toLowerCase() === 'credit' ? '1113' : '';
        const payerObj = {
            countryCode: paymentHeader.countryCompany,
            customerCode: paymentHeader.customerNo1,
            referenceCode: response.idTransaction,
            amount: paymentHeader.amountLocalCurrency,
            companyCode: paymentHeader.companyCode,
            paymentType: psePaymentType,
            customerDesc: paymentHeader.client,
            userAccount: storeDataInfo.UserAccount,
        urlRedirect: window.location.href.substring(0, document.location.href.lastIndexOf( '/' ))
            + '/return?token=' + storeDataInfo.Token + '&amp;c=' + paymentHeader.countryCompany + '&amp;b=BDO01'  + '&amp;r=' + response.idTransaction,
            externalOrder: storeDataInfo.ExternalOrder
        };

        return payerObj;
    }

}
